export interface IPatientRecord {
  id: number;
  lastName: string;
  firstName: string;
  middleName: string;
  dateOfBirth: string;
  medicalRecordNumber: string;
  accountNumber: string;
  facility: string;
  application: string;
}

export const getPatientInfo = (store: {
  patient: { info: IPatientRecord | null };
}) => store.patient.info;
